import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const settingsCmdbFieldConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-cmdb-field-config',
	path: '/secure/admin/CmdbObjectFieldConfiguration',
};
